import * as React from 'react';
import {
  List,
  Datagrid,
  Filter,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  TextField,
  DateField,
  SelectByEnum,
  ReferenceField,
  ReferenceInput,
} from 'react-admin';
import { TextByEnum } from './custom/Enum';

const useTxtData = {
  table: {
    id: 'id',
    S_xumu_id: '畜牧',
    DataType: '数据类型',
    wendu: '温度',
    shidu: '湿度',
    danqi: '氨气',
    tiwen: '体温',
    yundongliang: '运动量',
    tizhong: '体重',
    shipingliang: '食欲量',
    AtTime: '采集时间',
  }
};

export const S_xumu_dataList = (props) => (
  <List {...props} filters={<Filters />}>
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <ReferenceField label={useTxtData.table.S_xumu_id} source="S_xumu_id" reference="Admin/CMSS_xumu">
        <TextField source="name" />
      </ReferenceField>
      <TextByEnum label={useTxtData.table.DataType} source="DataType" EnumName='api.Models.S_xumu_dataType' />
      <TextField label={useTxtData.table.wendu} source="wendu" />
      <TextField label={useTxtData.table.shidu} source="shidu" />
      <TextField label={useTxtData.table.danqi} source="danqi" />
      <TextField label={useTxtData.table.tiwen} source="tiwen" />
      <TextField label={useTxtData.table.yundongliang} source="yundongliang" />
      <TextField label={useTxtData.table.tizhong} source="tizhong" />
      <DateField label={useTxtData.table.AtTime} source="AtTime" showTime />
    </Datagrid>
  </List>
);

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu" alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
    <SelectInput label={useTxtData.table.DataType} source="DataType" choices={[
      { id: '传感器', name: '传感器' },
      { id: '电子耳标', name: '电子耳标' },
      { id: '体征监测', name: '体征监测' },
    ]} />
  </Filter>
);

export const S_xumu_dataEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <SelectInput label={useTxtData.table.DataType} source="DataType" choices={[
        { id: '传感器', name: '传感器' },
        { id: '电子耳标', name: '电子耳标' },
        { id: '体征监测', name: '体征监测' },
      ]} />
      <NumberInput label={useTxtData.table.wendu} source="wendu" />
      <NumberInput label={useTxtData.table.shidu} source="shidu" />
      <NumberInput label={useTxtData.table.danqi} source="danqi" />
      <NumberInput label={useTxtData.table.tiwen} source="tiwen" />
      <NumberInput label={useTxtData.table.yundongliang} source="yundongliang" />
      <NumberInput label={useTxtData.table.tizhong} source="tizhong" />
      <NumberInput label={useTxtData.table.shipingliang} source="shipingliang" />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Edit>
);

export const S_xumu_dataCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <SelectInput label={useTxtData.table.DataType} source="DataType" choices={[
        { id: '传感器', name: '传感器' },
        { id: '电子耳标', name: '电子耳��' },
        { id: '体征监测', name: '体征监测' },
      ]} />
      <NumberInput label={useTxtData.table.wendu} source="wendu" />
      <NumberInput label={useTxtData.table.shidu} source="shidu" />
      <NumberInput label={useTxtData.table.danqi} source="danqi" />
      <NumberInput label={useTxtData.table.tiwen} source="tiwen" />
      <NumberInput label={useTxtData.table.yundongliang} source="yundongliang" />
      <NumberInput label={useTxtData.table.tizhong} source="tizhong" />
      <NumberInput label={useTxtData.table.shipingliang} source="shipingliang" />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Create>
);